import { gql } from 'apollo-angular'

export const GET_ORGANIZATION_FILTER_ITEMS = gql`
  query getOrganizationFilterItems(
    $page: Int
    $limit: Int
    $where: Organization_where
  ) {
    Organizations(where: $where, page: $page, limit: $limit, sort: "name") {
      docs {
        id
        name
      }
      page
      totalPages
    }
  }
`
